<template>
  <section class="participants-container">
    <h3
      v-if="title"
      class="participants__title">
      {{ title }}
    </h3>
    <form
      v-if="!isAddParticipantsOpen"
      @submit.prevent="handleSubmit"
      class="participants-form">
      <people-list
        :family-owner-id="family && family.head.uid
          || (userSelectedContacts && userSelectedContacts[0] && userSelectedContacts[0].uid)"
        :family-owner-ids="[family && family.head.uid]"
        class="people-list"
        :users="filteredUserSelectedContacts"
        :show-delete-button="(family && (user.user === family.head.uid))
          || !familyMembers.length
          || true"
        :enable-access-check="!!family"
        :check-user-amount="false"
        message="dont show"
        :disable-focus="true"
        :show-add-button="false"
        :show-user-phone="true"
        @deleteUser="deleteUser"
        @linkClick="hideSettings"
        :add-link-to-users="true"
      />
      <div class="footer-buttons">
        <add-human-button
          v-if="((family && (user.user === family.head.uid)) || !familyMembers.length)
          && !isAddParticipantsOpen"
          variant="add"
          class="add-participants-button"
          @clicked="openAddParticipants"
        />
        <button-app
          @clicked="quitFamily"
          :disabled="!family || this.filteredUserSelectedContacts.length === 0"
          class="delete-user-button"
        >
          {{ familyQuitButtonText }}
        </button-app>
      </div>
<!--      <div-->
<!--        v-if="!isAddParticipantsOpen"-->
<!--        class="form-buttons">-->
<!--        <button-app-->
<!--          @clicked="cancelSubmit"-->
<!--          type="button"-->
<!--          class="form-button form-button_left"-->
<!--          color-scheme="gray"-->
<!--        >-->
<!--          {{ $t('CP.cancel') }}-->
<!--        </button-app>-->
<!--        <button-app-->
<!--          :disabled="(!isFamilyMembersListChanged)-->
<!--            || (family && (user.user !== family.head.uid))"-->
<!--          type="submit"-->
<!--          class="form-button"-->
<!--          color-scheme="blue"-->
<!--        >-->
<!--          {{ $t('CP.save') }}-->
<!--        </button-app>-->
<!--      </div>-->
    </form>
<!--      <add-family-participants-form-->
<!--        v-else-if="isAddParticipantsOpen"-->
<!--        class="add-participants-form"-->
<!--        @submit="isAddParticipantsOpen = !isAddParticipantsOpen"-->
<!--        @cancel="isAddParticipantsOpen = !isAddParticipantsOpen"-->
<!--      />-->
  </section>
</template>

<script>
import { mapState } from 'vuex';
import {
  DELETE_USER_SELECTED_CONTACTS, UPDATE_USER_REQUEST,
} from '@/store/user/types';
// import ButtonApp from '../../components/Button/ButtonApp';
import PeopleList from '../../components/PeopleList/PeopleList';
import AddHumanButton from '../../components/AddHumanButton/AddHumanButton';
import ButtonApp from '../../components/Button/ButtonApp';
// import AddFamilyParticipantsForm from '../AddFamilyParticipantsForm/AddFamilyParticipantsForm';

export default {
  name: 'FamilyParticipantsForm',
  components: {
    ButtonApp,
    // AddFamilyParticipantsForm,
    AddHumanButton,
    PeopleList,
    // ButtonApp,
  },
  props: {
    title: {
      type: String,
      default() {
        return this.$t('CP.participants');
      },
    },
  },
  data() {
    return {
      isAddParticipantsOpen: false,
    };
  },
  mounted() {
    this.$emit('familyChangeStatus', false);
  },
  watch: {
    isFamilyMembersListChanged(newValue) {
      this.$emit('familyChangeStatus', newValue);
    },
    family() {
      this.$forceUpdate();
    },
  },
  computed: {
    ...mapState({
      family: (state) => {
        try {
          return state.user.user.family;
        } catch (e) {
          return {};
        }
      },
      user: (state) => state.user.user,
      userPhone: (state) => state.user.user.phone,
      userSelectedContacts: (state) => state.user.userSelectedContacts,
    }),
    familyQuitButtonText() {
      if (this.user.user === (this.family && this.family.head && this.family.head.uid)) {
        return this.$t('CP.deleteFamily');
      }
      return this.$t('CP.quitFamily');
    },
    filteredUserSelectedContacts() {
      return this.userSelectedContacts.filter((contact) => contact.uid !== this.user.user);
    },
    familyMembers() {
      const { user } = this;
      const family = [];
      if (user && user.family && user.family.members && user.family.head) {
        if (user.family.head.uid === user.user) {
          family.push({
            ...user.family.head,
            full_name: this.$t('CP.me'),
          });
        } else {
          family.push(user.family.head);
        }
        user.family.members.forEach((member) => {
          if (member.uid === user.user) {
            family.push({
              ...member,
              full_name: this.$t('CP.me'),
            });
          } else {
            family.push(member);
          }
        });
      }
      return family;
    },
    isFamilyMembersListChanged() {
      const familyMembersWithoutUser = this.familyMembers
        .filter((member) => member.uid !== this.user.user);
      const userSelectedContactsWithoutUser = this.userSelectedContacts
        .filter((member) => member.uid !== this.user.user);
      let isFamilyMembersListChanged = false;

      userSelectedContactsWithoutUser.forEach((contact) => {
        if (familyMembersWithoutUser.findIndex((member) => contact.phone === member.phone) === -1) {
          isFamilyMembersListChanged = true;
        }
      });
      if (isFamilyMembersListChanged
        || (userSelectedContactsWithoutUser.length !== familyMembersWithoutUser.length)) {
        return true;
      }
      return false;
    },
  },
  methods: {
    hideSettings() {
      this.$bvModal.hide('family-participants');
      this.$bvModal.hide('settings');
    },
    cancelSubmit() {
      this.$bvModal.hide('family-participants');
    },
    async handleSubmit() {
      if (this.family
        && this.user.user !== this.family.head.uid
        && this.familyMembers.length) {
        this.$bvModal.hide('family-participants');
        return;
      }
      const members = this.userSelectedContacts
        .filter((member) => member.phone !== this.user.phone)
        .map((member) => member.phone);
      this.$store.dispatch(UPDATE_USER_REQUEST, {
        family: {
          head: this.userPhone,
          members,
        },
      });
      this.$store.commit(DELETE_USER_SELECTED_CONTACTS);
      this.$bvModal.hide('family-participants');
    },
    quitFamily() {
      // this.$store.dispatch(UPDATE_USER_REQUEST, {
      //   family: {
      //     head: this.userPhone,
      //   },
      // });
      this.$store.commit(DELETE_USER_SELECTED_CONTACTS);
    },
    async deleteUser(user) {
      // if (user.uid === this.user.user) {
      //   this.$store.dispatch(UPDATE_USER_REQUEST, {
      //     family: {
      //       head: this.userPhone,
      //     },
      //   });
      //   this.$store.commit(DELETE_USER_SELECTED_CONTACTS);
      //   this.$bvModal.hide('family-participants');
      //   return;
      // }
      // console.log(this.user.user !== (this.family && this.family.head.uid), user);
      // if (this.user.user !== (this.family && this.family.head.uid)) return;
      this.$store.commit(DELETE_USER_SELECTED_CONTACTS, user);
    },
    openAddParticipants() {
      this.$bvModal.show('add-family-participants');
      // this.isAddParticipantsOpen = !this.isAddParticipantsOpen;
    },
  },
};
</script>

<style scoped>
.participants-container {
  color: var(--text-main-color);
}
.participants-form {
  padding: 0 calc(32px - 1rem);
}
.participants__title {
  margin: 0 0 26px;
}
.people-list {
  margin: 0 -5px 30px;
  padding: 5px;
  max-height: 50vh;
}
.footer-buttons {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.add-participants-button {
  /*margin: 0 0 30px;*/
  flex: 0 1 47%;
  margin: 0;
}
.delete-user-button {
  flex: 0 1 47%;
  margin: 0 0 0 auto;
  padding: 6px;
}
.add-participants-form {
  padding: 0;
}
.form-buttons {
  display: flex;
}
.form-button {
  font-size: 13px;
  font-weight: bold;
  height: 38px;
  flex: 1 0 40%;
  margin: 0;
}
.form-button_left {
  margin: 0 8px 0 0;
}
</style>
